

export interface ISolicitudesPedidoPagingRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: SolicitudesPedido[];
}
export interface Detalle {
  codigo: string;
  descripcion: string;
  cantidad: number;
  cantidad_recibida: number;
  medida: number;
  precio_unitario_sin_iva: number;
  total: number;
  subtotal: number;
  iva: number;
  total_final: number;
}
export interface SolicitudesPedido {
  id_solicitud_pedido?: string;
  observaciones?:{
    observacionSolicitudPedido?: string;
    observacionRevisionSolicitudPedido?:string;
  };
  motivo_rechazo?:string;
  estado_solicitud?: string;
  referencia?:string;
  bodega?: string;
  user?: string;
  /* departamento: number;
  tipo_compra: number; */
  productos?: ProductoData[]; // Agregamos el array de detalles aquí
}

export interface ProductoData{
  cantidad:string;
  producto_data:{
    unidad_medida: string;
  }
  
}


export enum EstadosSolicitudPeodidoEnum {
  ESPERA = 'EN ESPERA',
  APROBADAS = 'APROBADO',
  ABIERTO = 'ABIERTO',
  CANCELADO= 'CANCELADO',
  RECHAZADO = 'RECHAZADO',
  FINALIZADO='FINALIZADO'
}